import { ValueGetterParams } from "ag-grid-community";
import { readDataByDotSeparatedString } from "../../../../../ag-grid/utils/helpers/readDataByDotSeparatedString";
import {
  CapacityMode,
  FilteredDynamoDbTableResourceItem,
} from "@/services/cloudchipr.api";

export const dynamoDbCapacityModeValueGetter = ({
  data,
  column,
}: ValueGetterParams<FilteredDynamoDbTableResourceItem>) => {
  const capacityMode = data?.resource?.capacity_mode;

  const colId = column?.getColId() ?? "";

  const readWriteCapacityMode = readDataByDotSeparatedString(
    colId,
    data,
  ) as CapacityMode;

  const currentUnits =
    !!readWriteCapacityMode?.current_provisioned_units &&
    `(${readWriteCapacityMode?.current_provisioned_units})`;

  return `${capacityMode} ${currentUnits || ""}`;
};
